/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/ContactBooth.glb -o src/models/ContactBooth.jsx --draco --transform --simplify --resolution=512 
Files: public/ContactBooth.glb [17.54MB] > /Users/radek/Documents/GIthub/CoffeeCoded/coffeecoded/src/models/ContactBooth-transformed.glb [1.33MB] (92%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'
import modelUrl from '../assets/models/ContactBooth-transformed.glb'

export function Model(props) {
  const { nodes, materials } = useGLTF(modelUrl)
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes['tripo_node_52bbd55e-454f-419d-b04d-5773f7482032'].geometry} material={materials['tripo_material_52bbd55e-454f-419d-b04d-5773f7482032']} />
    </group>
  )
}

useGLTF.preload(modelUrl)
